var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryTrms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 150,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#96632C",
    stroke: "#565655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M126.975 63.805l51.211-53.53a7.262 7.262 0 0110.445.004 7.263 7.263 0 01-.414 10.488L133.01 70.053a4.357 4.357 0 01-6.142-.107 4.358 4.358 0 01.107-6.142z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.353,
    d: "M131.034 68.005l55.272-49.348a4.403 4.403 0 001.514-3.159 4.38 4.38 0 00-1.237-3.242 4.387 4.387 0 00-3.098-1.348"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD731",
    stroke: "#565655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M123.367 66.673l6.651 6.887a3.621 3.621 0 005.105.09 3.622 3.622 0 00.089-5.106l-6.651-6.887a3.621 3.621 0 00-5.105-.09 3.622 3.622 0 00-.089 5.106z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 7.253,
    fill: "#FFB133",
    stroke: "#565655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "scale(-1 1) rotate(-46 80.342 158.362)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD731",
    stroke: "#565655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M95.937 67.878c9.09-8.778 23.708-8.523 32.487.567 8.778 9.09 8.523 23.708-.567 32.487l-19.052 18.398-31.92-33.054 19.052-18.398z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.353,
    d: "M108.894 114.225l16.455-15.891c7.68-7.417 7.895-19.702.478-27.382"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD731",
    stroke: "#565655",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M71.638 87.054l36.206 37.492a4.327 4.327 0 006.102.107 4.329 4.329 0 00.107-6.103L77.847 81.058a4.328 4.328 0 00-6.102-.106 4.33 4.33 0 00-.107 6.102z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.353,
    d: "M110.442 122.038a.715.715 0 00.996.018.716.716 0 00.017-.997L75.25 83.567"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.882,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.176 134.603c4.25 1.577 8.152 1.328 11.707-.746 3.554-2.074 6.104-5.989 7.649-11.746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.049 140.011c5.182 1.922 9.939 1.619 14.272-.909s7.442-7.302 9.326-14.321"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.882,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.78 52.026s-5.449-1.694-11.623-.203C89.983 53.313 85 58.625 85 58.625M108.371 46.578s-6.288-2.107-13.306-.593c-7.018 1.513-12.553 7.437-12.553 7.437"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTrms);
export default __webpack_public_path__ + "static/media/deliveryTrms.c8d88478ea5b8da45ecc03456678a789.svg";
export { ForwardRef as ReactComponent };